import styled from 'styled-components/macro';

import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useToast
} from "@chakra-ui/react";
import {useFeedback} from "../../store/feedback";
import {useAward} from "../../api/awards";
import {themecolors} from "../../utils/themecolors";

const Description = styled.div``;
const Quantity = styled.div``;
const Heading = styled.div``;

const ConfirmAward = styled(({className, onClose, id, type}) => {
    const toast = useToast();
    const {error, feedbackCh} = useFeedback();
    const award = useAward(feedbackCh);
    const handleContinue = async () => {
        onClose();
        await award(id, type);
        toast({
            title: `Successfully awarded!`,
            status: 'success',
            isClosable: true,
        })
    }
    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Are you sure?</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6} className={className}>
                    <p>Giving an award will use 1 award credit, which cannot be refunded.</p>
                </ModalBody>

                <ModalFooter>

                    <Button variant="cancel" mr={3} onClick={onClose}>Close</Button>
                    <Button type='submit' variant="blue" onClick={handleContinue}>
                        Give Award
                    </Button>

                </ModalFooter>
            </ModalContent>
        </Modal>
    )})`
    ${Description} {
      margin-bottom: 6px;
    }
  ${Quantity} {
    padding-top: 2px;
    font-size: 15px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Heading} {
    margin-top: 16px;
    font-weight: 500;
    font-size: 16px;
  }
`;

export default ConfirmAward;
